//  Copyright (c) 2017-2019 First Foundry LLC. All rights reserved.

import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { compose } from 'recompose'
import { PageNotFound } from 'components/pages/ErrorPage'
import withFixedPageWidth from 'components/common/container/withFixedPageWidth'
import PageContent from 'components/pages/PageContent'
import ProductLogs from './ProductLogs'

const ProductLogsPage = () => (
  <PageContent title="Product Change Log">
    <Switch>
      <Route
        exact
        path="/productlogs/:id"
        component={compose(
          withFixedPageWidth,
        )(ProductLogs)}
      />
      {/* If none of the above routes matches, show the 404 error page */}
      <Route component={PageNotFound(true)} />
    </Switch>
  </PageContent>
)

export default ProductLogsPage
